<button class="feed border-0 p-0" *ngIf="syndicationItems && syndicationItems.length !== 0">
  <my-global-icon
    role="button" aria-label="Open syndication dropdown" i18n-aria-label
    *ngIf="syndicationItems.length !== 0" [ngbPopover]="feedsList" [autoClose]="true" placement="bottom left auto"
    class="icon-syndication" iconName="syndication"
  >
  </my-global-icon>

  <ng-template #feedsList>
    <a *ngFor="let item of syndicationItems" [href]="item.url" target="_blank" rel="noopener noreferrer">{{ item.label }}</a>
  </ng-template>
</button>
